import { observer } from 'mobx-react';
import { FC, ReactElement, memo, useCallback } from 'react';
import mealsStore from '../../store/mealsStore';
import { modalStore } from 'src/mobx/modalStore';
import AddButton from '~/view/components/Controls/AddButton/AddButton';

interface IProps {
  group_id: number;
}

const AddItemChoiceButton: FC<IProps> = memo(
  observer((props: IProps): ReactElement => {
    const onAddChoice = useCallback(() => {
      if (!mealsStore.meal) return;

      modalStore.openMealChoiceEditModal({
        groupId: props.group_id,
        sizes: mealsStore.meal.sizes,
        items: mealsStore.meal.items,
        onSubmit: mealsStore.onEditChoice,
        onDelete: mealsStore.onDeleteChoice,
      });
    }, [props.group_id, mealsStore.meal?.sizes, mealsStore.meal?.items]);

    return <AddButton title="add_item_choice" onAdd={onAddChoice} />;
  })
);

export default AddItemChoiceButton;
